module.exports = "<svg viewBox=\"0 0 24 24\"><g id=\"caret\" transform=\"translate(2.000000, 3.000000)\" fill-rule=\"nonzero\"><polygon points=\"3.1231456 0.32943568 0.86323447 2.46718624 9.5186981 11.6172615 18.8632345 2.5123409 16.6923073 0.28428102 9.6090173 7.1859389\"></polygon></g><g id=\"caret\" transform=\"translate(2.000000, 10.000000)\" fill-rule=\"nonzero\"><polygon points=\"3.1231456 0.32943568 0.86323447 2.46718624 9.5186981 11.6172615 18.8632345 2.5123409 16.6923073 0.28428102 9.6090173 7.1859389\"></polygon></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/chevron-double.svg
// module id = 714
// module chunks = 0